export default __webpack_public_path__ + "static/media/antiviruspopup.98332630.png";